/**
 * HTML Element
 *
 */

import Tr from '../components/table/TableTr'
export * from '../components/table/TableTr'
export default Tr
